import uuid from 'uuid';

interface Props {
  videoId: string;
  trimId?: string | null;
}

export interface VideoSessionData {
  id: string;
  videoId: string;
  trimId: string | null;
}

function createVideoSessionData({ videoId, trimId }: Props): VideoSessionData {
  return {
    id: uuid.v4(),
    videoId,
    trimId: trimId || null,
  };
}

export default createVideoSessionData;
